import { MlmTreeNode } from "../../../../Objects/interfaces/MlmTypes";
import { SponsorshipEnum, SponsorshipEnumColor } from "../../../../Enum/SponsorshipEnum";

/**
 * Couleur d'accent par niveau : déclinaison du turquoise Verified Trainer
 * (#0dcebf), de plus en plus foncé en descendant dans le réseau. Une seule
 * famille de couleur pour que l'arbre et le tableau restent dans la charte.
 */
export const MLM_LEVEL_COLORS: Record<number, string> = {
  1: "#0dcebf",
  2: "#0ba899",
  3: "#098a80",
  4: "#076d66",
  5: "#05514c",
};

export const mlmLevelColor = (level: number): string =>
  MLM_LEVEL_COLORS[level] ?? "#4b5563";

export const formatEuro = (value: number | string | null | undefined): string =>
  `${Number(value ?? 0).toFixed(2)} €`;

export const mlmNodeFullName = (node: MlmTreeNode): string =>
  [node.teachr.firstName, node.teachr.lastName].filter(Boolean).join(" ") || `Coach #${node.teachr.id}`;

/** Statut brut backend ("REGISTER") → { title, color } de SponsorshipEnumColor */
export const sponsorshipStatusDisplay = (
  statut: string | null
): { title: string; color: string } | null => {
  if (!statut) return null;
  const key = (Object.keys(SponsorshipEnum) as (keyof typeof SponsorshipEnum)[]).find(
    (k) => SponsorshipEnum[k] === statut
  );
  return key ? SponsorshipEnumColor[key] : { title: statut, color: "" };
};

/** Aplatit l'arbre (sans la racine) : une ligne par filleul du réseau. */
export const flattenMlmTree = (root: MlmTreeNode): MlmTreeNode[] => {
  const rows: MlmTreeNode[] = [];
  const walk = (node: MlmTreeNode) => {
    node.children.forEach((child) => {
      rows.push(child);
      walk(child);
    });
  };
  walk(root);
  return rows;
};
